import { Routes, Route, BrowserRouter } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import Layout from "./components/Layout";
import Dashboard from "./pages/Dashboard";
import BudgetWizard from "./pages/BudgetWizard";
import Catalog from "./pages/Catalog";
import "./App.css";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Dashboard />} />
          <Route path="/nuevo" element={<BudgetWizard />} />
          <Route path="/presupuesto/:id" element={<BudgetWizard />} />
          <Route path="/catalogo" element={<Catalog />} />
        </Route>
      </Routes>
      <Toaster richColors position="top-right" />
    </BrowserRouter>
  );
}

export default App;
